import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=c6369ce6&scoped=true&"
import script from "./TextBlock.vue?vue&type=script&lang=js&"
export * from "./TextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6369ce6",
  null
  
)

export default component.exports